module.exports = __webpack_public_path__ + "static/media/ro.46524c84.svg";